/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsExports = {
  aws_project_region: "us-east-2",
  aws_cognito_identity_pool_id:
    "us-east-2:f44dd18c-fc78-4269-96c9-b2f570b03219",
  aws_cognito_region: "us-east-2",
  aws_user_pools_id: "us-east-2_0wsSohlzP",
  aws_user_pools_web_client_id: "4uujbkv7lfm9vuctjsive1i8vg",
  oauth: {},
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "ON",
  aws_cognito_mfa_types: ["TOTP"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
};

export default awsExports;
